import { Grid } from "@mui/material";
import React from "react";
import type {
  CalculateByField,
  FieldConfiguration,
} from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { MeasureField } from "../../../../../../../../../api/types/svTypes.ts";
import { getMeasureCalculateByField } from "../../../../../utilities/isConfigurationValid.ts";
import CalculateByFieldControl from "../CalculateByFieldControl.tsx";

interface Props {
  measure: MeasureField;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}

export default function ValueFieldsMenuItem({ measure, saveChanges, readonly }: Props) {
  const calcField = React.useMemo(() => getMeasureCalculateByField(measure), [measure]);

  const handleOnChange = React.useCallback(
    (calculateBy: CalculateByField) => {
      saveChanges({ calculateByField: calculateBy }, false);
    },
    [saveChanges]
  );

  if (!calcField) return null;

  return (
    <Grid container sx={{ width: "100%" }}>
      <CalculateByFieldControl
        calculateBy={calcField}
        disabled={!measure.meta.capabilities.changeCalculatedBy || readonly}
        onChange={handleOnChange}
      />
    </Grid>
  );
}
